import { Paper, TextField, makeStyles } from '@material-ui/core';

import { Organization } from '../../types/organization.type';

type Props = {
  siren: string;
  vatNumber: string;
  handleChange: ({ field, value }: { field: keyof Organization; value: string }) => void;
};

const useStyles = makeStyles({
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',

    '& > *': {
      flex: 1,
    },
  },
});

export default function OrganizationLegalIdentifiersSection({ siren, vatNumber, handleChange }: Props) {
  const classes = useStyles();

  return (
    <section>
      <h4>Identifiants l&eacute;gaux</h4>
      <Paper>
        <section className={classes.row}>
          <TextField
            id="organization-siren"
            label="SIREN"
            type="text"
            value={siren}
            variant="outlined"
            fullWidth
            onChange={(event) => handleChange({ field: 'siren', value: event.target.value })}
          />
          <TextField
            id="organization-vat-number"
            label="N° TVA"
            type="text"
            value={vatNumber}
            variant="outlined"
            fullWidth
            onChange={(event) => handleChange({ field: 'vatNumber', value: event.target.value })}
          />
        </section>
      </Paper>
    </section>
  );
}
